export const mainNavigationOnboardingDocuments = [
  {
    exact: true,
    path: '/onboarding/iharmoni_docs/:activeDoc',
  },
];
